import {HttpService} from "../http/HttpService";
import axios from "axios";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {BetLog, ListBetsRequest, ListBetsResponse, ListUserBetSummary, SportsBet} from "../http/protocol";


export class SportBetsService  extends AbstractAdminEntityService<SportsBet, ListBetsResponse>  {

    constructor(http : HttpService) {
        super("/sportsbetting/bet", http)
    }

    processEvent(jsonString:string):Promise<BetLog> {
        axios.create({headers : {"Content-type" : "text/plain"}})
        return  new Promise((resolve,reject)=> {
            axios.post(`${this.http.baseUrl}${this.entityPath}/process-event`,jsonString, { withCredentials : true })
                .then((response:any) => resolve(response.data))
                .catch((e:any) => this.http.handleError('/process-event', e, reject))
        })
    }
    
    public async getUserBetSummary(request: ListBetsRequest) : Promise<ListUserBetSummary> {
        return this.http.post(this.entityPath + "/user-bet-summary", request);
    }

    public async updateStatus(request: SportsBet) : Promise<SportsBet> {
        return this.http.post(this.entityPath + "/status", request);
    }
}